const state = {
    userInfo: {},
    // 用户头像（base64 或 URL，用于顶部栏同步显示）
    avatar: '',
    // 账号改造：用户类型（PERSONAL / ENTERPRISE / ENTERPRISE_ROOT）
    accountUserType: '',
    // SchemaTree 对应的用户ID（用于检测用户切换后强制刷新树数据）
    treeUserId: null,
    // 表格表头样式配置
    header_cell_style: {
        background: '#344962',
        color: '#fff',
        fontWeight: 600,
        height: '40px',
        borderColor: 'rgb(197, 208, 218)',
        'text-align': 'center'
    },
    CURRENT_SYSTEM_MENU: [], // 当前系统菜单数据
    RESOURE_SYSTEM_MENU: [],
    // 表格的操作按钮图表
    icons: {
        compiles: 'el-icon-edit-outline',
        omit: 'el-icon-delete',
        href: 'el-icon-link',
        pause: 'el-icon-video-pause',
        play: 'el-icon-video-play',
        // date:2022 03 08
        edit: 'el-icon-edit-outline', //编辑
        delete: 'el-icon-delete' //删除
    },
    // unit 单位哈希表匹配
    unit: {},

    // 异常类型  哈希表匹配
    exType: {},
    // 挂载类型
    carrierType: {},
    // 挂载模式
    carrierMode: {}
};
export default state;
